(function(angular){
	"use strict";
	// This provides a back-compat mapping for old bootstrap modal defs using new bootstrap modal defs.
	var module = angular.module("ui.bootstrap");
	module.provider("$modal", function(){
		// This is back-compating the $modal and $modalInstance API by mapping it to the uib version as much as possible.
		this.$get = ["$uibModal", 
			function($uibModal){
			return $uibModal;
		}];
	});
	
	module.decorator("$controller", ["$delegate", function($delegate){
		return function(controller, ctrlLocals, bool, controllerAs){
			if(ctrlLocals && ctrlLocals.$uibModalInstance){
				// We need to back-compat map $uibModalInstance to $modalInstance.
				ctrlLocals.$modalInstance = ctrlLocals.$uibModalInstance;
			}
			return $delegate(controller, ctrlLocals, bool, controllerAs);
		};
	}]);

	module.provider("$modalStack", function(){
		// This is back-compating the $modal and $modalInstance API by mapping it to the uib version as much as possible.
		this.$get = ["$uibModalStack", 
			function($uibModalStack){
			return $uibModalStack;
		}];
	});
})(window.angular);
